import React, {useState,useEffect} from "react";
import { Spin,Tooltip } from "antd";
import Razorpay from "../../asserts/Razorpay2.png"
import dashes1 from "../../asserts/dashes1.png";
import dashes2 from "../../asserts/dashes2.png";
import total from "../../asserts/Total.png"
import refund from "../../asserts/Refund.png"
import settled from "../../asserts/Settled.png"
import pendingimg from "../../asserts/Pending.png"
import icon1 from "../../asserts/Sales Icon.png"
import icon2 from "../../asserts/Order Icon.png"
import icon3 from "../../asserts/Disc Icon.png"
import {YAxis,XAxis,LineChart, Line, CartesianGrid, ResponsiveContainer,PieChart,Pie,Cell,Sector,Tooltip as ReTooltip } from "recharts";
import "../../App.css";
import { useSelector, useDispatch } from "react-redux";
import { GetRazorpayDetails } from "../../Api/Payments/Payments";
import {capitalizeFirstLetter} from "../Common/Captilization"
import exporticon from "../../asserts/Export.png"
import Commission from "./Commission";

export const RazorpaydashMobile = ({dateClear,spinning,setSpinning,loader,setLoad,table}) => {
  console.log(table,"table")
    const dispatch = useDispatch();
    const [activePicker,setActivePicker]=useState("Weekly")
      const [weekNumber, setWeekNumber] = useState(null);
      const[month,setMonth]=useState(null);
      const [year,setYear]=useState(null);
       const [hoveredIndex, setHoveredIndex] = useState(null);
       console.log(hoveredIndex,"HHHHHHover")
       const [activeIndexes] = useState([0, 1, 2]);
  
    const getRazorpayDetails =
    useSelector((state) => state.crm.razorpay_details) || {};
    console.log(getRazorpayDetails, "detaildetails")
     const lineChartDetails = getRazorpayDetails.chartDetails || []
         const upi=getRazorpayDetails?.paymentBreakDown?.upi
         const card=getRazorpayDetails?.paymentBreakDown?.card
         const others=getRazorpayDetails?.paymentBreakDown?.others
       const  percentageUpi = Math.round((upi / (upi+card+others)) * 100)
       const  percentageCard = Math.round((card / (upi+card+others)) * 100)
       const  percentageOthers = Math.round((others / (upi+card+others)) * 100)
     
           const DataPiePayment = [
         {
           name: "UPI",
           color: "#02CA70",
           value: upi,
         },
         {
           name:"Card",
           color: "#FFD700",
           value: card,
         },
         {
           name:"Others",
           color: "#3E7DFB",
           value: others,
         }
       ]
const COLORS = ["#02CA70",'#FFD700' , "#3E7DFB"];
  const totalValue = upi + card + others;

  const hoveredName =
    hoveredIndex !== null ? DataPiePayment[hoveredIndex]?.name : null;
  const hoveredValue =
    hoveredIndex !== null ? DataPiePayment[hoveredIndex]?.value : totalValue;

  const labelTitle =
    hoveredName === "Others"
      ? "Other Payment"
      : hoveredName === "Card"
      ? "Card Payment"
      : hoveredName === "UPI"
      ? "UPI Payment"
      : "Total Count";



       useEffect(() => {
         const currentWeek = getWeekNumber(new Date());
         setWeekNumber(currentWeek);
         
     const currentDate = new Date();
         const currentMonth = currentDate.toLocaleString('default', { month: 'short' }); 
         setMonth(currentMonth);
         const currentyear=new Date();
         const currentYear=currentyear.toLocaleString('default',{year:'numeric'});
         setYear(currentYear);
     
       }, []);

       function getWeekNumber(date) {
  const tempDate = new Date(date.getTime());
  tempDate.setHours(0, 0, 0, 0);
  tempDate.setDate(tempDate.getDate() + 3 - ((tempDate.getDay() + 6) % 7));
  const week1 = new Date(tempDate.getFullYear(), 0, 4);
  return (
    1 +
    Math.round(
      ((tempDate.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7
    )
  );
}


      const handleLineChartFilter = (value) => {
        console.log(value, "activeactive");
        if (value === "Weekly") {
            GetRazorpayDetails(dispatch,setSpinning,setLoad,"null","null",1);
          
        } else if (value === "Monthly") {
          
            GetRazorpayDetails(dispatch,setSpinning, setLoad, "null", "null", 2);
          
        } else if (value === "Yearly") {
    GetRazorpayDetails(dispatch,setSpinning, setLoad, "null", "null", 3);
      };
    }

    const formatNumber = (value) => {
    if (value === undefined || value === null || isNaN(value)) {
      return "Invalid value";
    }
    if (value >= 1000000) {
      return Math.floor((value / 1000000) * 10) / 10 + "m"; 
    } else if (value >= 1000) {
      return Math.floor((value / 1000) * 10) / 10 + "k"; 
    } else {
      return value.toString(); 
    }
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || payload.length === 0) return null;
  
    return (
      <div style={{
        backgroundColor: 'white',
        border: '1px solid #ccc',
        padding: '10px',
        borderRadius: '5px',
        fontSize: '12px'
      }}>
        <p style={{ margin: 0, fontWeight:'bold' }}>{label}</p>
  
        {payload.map((item, index) => (
          <p key={index} style={{ display: 'flex', alignItems: 'center', margin: '4px 0' }}>
            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                backgroundColor: item.color,
                display: 'inline-block',
                marginRight: 6
              }}
            />
           {capitalizeFirstLetter(item.name)} : {item.value === 0 ? '0' : `${(item.value / 1000).toFixed(1)}k`}
          </p>
        ))}
      </div>
    );
  };



return (
  <div className="h-screen ">
    <div className="w-full h-[80%] rounded-[1vw] bg-[#fff]  border-[#1f4b7f] border-t-[0.1vw] border-l-[0.1vw] border-r-[0.75vw] border-b-[0.75vw] p-[1vw] relative overflow-y-scroll">
      {spinning ? (
           <div>
               <div className="absolute top-[30vh] left-[45vw] flex justify-center items-center  z-10">
                      <Spin size="large" />
                    </div>
                    <div className="absolute top-[37vh] left-[20vw] p-[1.5vw] flex flex-col justify-center items-center z-10 col-span-6 text-gray-500 font-bold text-[4vw]">
  <p>Hold on,loading...</p>
  <p>Please don’t refresh or leave.</p>

</div>

          
            </div>
        ) : (

  table==="razorpaydashboard"?(
    <div className="grid grid-cols-2 gap-x-2 gap-y-2">
<div className="col-span-1 grid grid-rows-3 gap-x-2 gap-y-2">
  <div className="bg-green-400 row-span-1 rounded-[1.5vw] overflow-hidden">
  {/* Header */}
  <div className="bg-green-500 rounded-t-[1.5vw] px-[2vw] py-[1vw]">
    <p className="text-[4.5vw] text-white font-semibold ">
      Total Collections
    </p>
  </div>

  {/* Body */}
  <div className="px-[2vw] py-[1vw] flex justify-between items-center">
    <div className="text-white">
      <p className="text-[5vw] font-bold">
        {getRazorpayDetails?.cardDetails?.totalCollection >= 1000 ? (
          <Tooltip
            placement="right"
            title={`₹ ${Number(getRazorpayDetails?.cardDetails?.totalCollection).toLocaleString("en-IN")}`}
            className="cursor-pointer text-[#1F487C]"
            color="white"
            overlayInnerStyle={{
              color: "#1F487C",
              fontSize: "2vw",
            }}
          >
            <span className="text-white">
              ₹ {formatNumber(Number(getRazorpayDetails?.cardDetails?.totalCollection).toFixed(2))}
            </span>
          </Tooltip>
        ) : (
          <span className="text-white">
            ₹ {Number(getRazorpayDetails?.cardDetails?.totalCollection).toFixed(2)}
          </span>
        )}
      </p>
      <p className="underline text-[3vw] cursor-pointer mt-[1vw]">
        View Entire List
      </p>
    </div>

    <div className="w-[9vw] h-auto">
      <img
        src={total}
        className="w-full h-auto object-contain"
        alt="Total Amount"
      />
    </div>
  </div>
</div>


<div className="bg-red-400 row-span-1 rounded-[1.5vw] overflow-hidden relative">
  {/* Heading */}
  <div className="px-[2vw] pt-[1.5vw] pb-[1vw] bg-red-500">
    <p className="text-[4.5vw] text-white font-semibold z-[10]">
      Refund Amounts
    </p>
  </div>

  {/* Main Content */}
  <div className="px-[2vw] pb-[1vw] flex justify-between items-center z-[10] relative">
    <div className="text-white">
      <p className="text-[5vw] font-bold">
        {getRazorpayDetails?.cardDetails?.refundedAmount >= 1000 ? (
          <Tooltip
            placement="right"
            title={`₹ ${Number(getRazorpayDetails?.cardDetails?.refundedAmount).toLocaleString("en-IN")}`}
            className="cursor-pointer text-[#1F487C]"
            color="white"
            overlayInnerStyle={{
              color: "#1F487C",
              fontSize: "2vw",
            }}
          >
            <span className="text-white">
              ₹ {formatNumber(Number(getRazorpayDetails?.cardDetails?.refundedAmount).toFixed(2))}
            </span>
          </Tooltip>
        ) : (
          <span className="text-white">
            ₹ {Number(getRazorpayDetails?.cardDetails?.refundedAmount).toFixed(2)}
          </span>
        )}
      </p>
      <p className="underline text-[3vw] cursor-pointer mt-[1vw]">
        View Entire List
      </p>
    </div>

    {/* Refund Icon */}
    <div className="w-[9vw] h-auto">
      <img
        src={refund}
        className="w-full h-auto object-contain"
        alt="Refunded"
      />
    </div>
  </div>
</div>

<div className="bg-blue-400 row-span-1 rounded-[1.5vw] overflow-hidden relative">
  {/* Title */}
  <div className="px-[2vw] pt-[1.5vw] pb-[1vw] bg-blue-500">
    <p className="text-[4.5vw] text-white font-semibold z-[10]">
      Settled to Bank
    </p>
  </div>

  {/* Content */}
  <div className="px-[2vw] pb-[1vw] flex justify-between items-center z-[10] relative">
    <div className="text-white">
      <p className="text-[5vw] font-bold">
        {getRazorpayDetails?.cardDetails?.settledToBank >= 1000 ? (
          <Tooltip
            placement="right"
            title={`₹ ${Number(getRazorpayDetails?.cardDetails?.settledToBank).toLocaleString("en-IN")}`}
            className="cursor-pointer text-[#1F487C]"
            color="white"
            overlayInnerStyle={{
              color: "#1F487C",
              fontSize: "2vw",
            }}
          >
            <span className="text-white">
              ₹ {formatNumber(Number(getRazorpayDetails?.cardDetails?.settledToBank).toFixed(2))}
            </span>
          </Tooltip>
        ) : (
          <span className="text-white">
            ₹ {Number(getRazorpayDetails?.cardDetails?.settledToBank).toFixed(2)}
          </span>
        )}
      </p>
      <p className="underline text-[3vw] cursor-pointer mt-[1vw]">
        View Entire List
      </p>
    </div>
    <div className="w-[9vw] h-auto">
      <img
        src={settled}
        className="w-full h-auto object-contain"
        alt="Settlement"
      />
    </div>

  </div>
    </div>

  </div>
  <div className="col-span-1 grid grid-rows-3 gap-x-2 gap-y-2">
        <div className="  row-span-3 bg-gradient-to-b from-[#A9F9EE] to-[#F9FFF1] rounded-[1.5vw] shadow-lg p-[1vw] ml-[0.5vw] relative">
         <div className="flex flex-col items-center justify-center">
  <p className="text-[#737373] text-[5vw]">Payment</p>
  <p className="text-[#0A0A0A] font-bold text-[4.5vw] -mt-[1vw]">Breakdown</p>
</div>

<div className="mt-[1vw] flex justify-center p-[1vw]">
  <div className="flex flex-col gap-[1.5vw]">
    
    {/* UPI Payment */}
    <div className="flex text-[2.5vw]">
      <p className="bg-[#02CA70] text-white font-bold w-[19vw] text-center rounded-l-full py-[1vw]">
        UPI Payment
      </p>
      <p className="bg-green-100 w-[16vw] font-semibold text-center rounded-r-full py-[1vw]">
        {percentageUpi} %
      </p>
    </div>

    {/* Card Payment */}
    <div className="flex text-[2.5vw]">
      <p className="bg-yellow-400 text-white font-bold w-[19vw] text-center rounded-l-full py-[1vw]">
        Card Payment
      </p>
      <p className="bg-yellow-100 w-[16vw] font-semibold text-center rounded-r-full py-[1vw]">
        {percentageCard} %
      </p>
    </div>

    {/* Other Payment */}
    <div className="flex text-[2.5vw]">
      <p className="bg-blue-400 text-white font-bold w-[19vw] text-center rounded-l-full py-[1vw]">
        Other Payment
      </p>
      <p className="bg-blue-100 w-[16vw] font-semibold text-center rounded-r-full py-[1vw]">
        {percentageOthers} %
      </p>
    </div>

  </div>
</div>

          <div className= "mt-[0.5vw] w-full h-full absolute top-[4vw]  left-0">
            <ResponsiveContainer width="100%" height="100%">
 <PieChart>
          <Pie
            data={DataPiePayment}
            cx="50%"
            cy="68%"
            innerRadius="55%"
            outerRadius="75%"
            dataKey="value"
            activeIndex={hoveredIndex}
            onMouseEnter={(_, index) => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            activeShape={(props) => <Sector {...props} />}
          >
            {DataPiePayment.map((entry, index) => (
              <Cell key={index} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>

          <text
            x="50%"
            y="66%"
            textAnchor="middle"
            dominantBaseline="middle"
            style={{ pointerEvents: "none" }}
          >
            <tspan
              x="50%"
              fontSize="3.5vw"
              fontWeight="lighter"
              fill="#737373"
            >
              {labelTitle}
            </tspan>
            <tspan
              x="50%"
              dy="16"
              fontWeight="bold"
              fontSize="3vw"
              fill="black"
            >
              {hoveredValue}
            </tspan>
          </text>
        </PieChart>
</ResponsiveContainer>

          </div>
        </div>
    </div>
  


            <div className=" col-span-2 bg-gradient-to-b from-[#A9F9EE] to-[#F9FFF1] rounded-[1.5vw] px-[1vw] pt-[2vw] flex flex-col shadow-lg dash-container2 h-[45vh] p-[1vw] mt-[1vw]">
  
      <div className="flex justify-between items-center mb-[1vw]">
        <div className="flex flex-col gap-[0.25vw] leading-tight">
          <p className="text-[4vw] text-[#737373]">Total <span className="font-bold text-[3.2vw] text-[#0A0A0A]">Performance</span></p>
          
        </div>
        <div className="flex flex-row items-center gap-x-4">

            {
                           (!dateClear) ? <div className="border border-black text-[2.5vw] px-[2vw] py-[0.5vw] w-[12vw] rounded-[0.7vw]">
                        
                        {
                          activePicker==="Weekly"?<span className="flex justify-center font-bold"> W - {weekNumber}</span>:activePicker==="Monthly"?<span className="flex justify-center font-bold ">{month}</span> :activePicker==="Yearly"?<span className="flex justify-center font-bold">{year}</span>:" "
                        }
                        </div>:""}
  
          <div
            className={`flex items-center bg-[#1F4B7F80] p-[0.8vw] rounded-[1.2vw] w-[33vw]  ${
              dateClear ? "cursor-not-allowed" : ""
            }`}
          >
            {["Weekly", "Monthly", "Yearly"].map((type) => (
              <button
                key={type}
                onClick={() => {
                  setLoad(true);
                  if (activePicker !== type) {
                    setActivePicker(type);
                  }
                  handleLineChartFilter(type);
                }}
                className={`px-[1vw] py-[0.25vw] rounded-[0.5vw] text-[2.5vw] capitalize  ${
                  activePicker === type && !dateClear
                    ? "bg-white text-[#1F487C] font-bold"
                    : "text-white"
                } ${dateClear ? "pointer-events-none" : ""}`}
              >
                {type}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="w-full h-[33vh]  relative -ml-[6vw] mt-[1vw]">
        {loader ? (
          <div className="absolute inset-0 flex justify-center items-center z-10">
            <Spin size="large" />
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={lineChartDetails} layout="horizontal">
              <CartesianGrid horizontal={true} vertical={false} />
              <XAxis dataKey="name" padding={{ left: 30, right: 0 }} fontSize={'2.7vw'}/>
              <YAxis
                fontSize={'2.7vw'}
                tickFormatter={(value) =>
                  value === 0 ? "0" : `${value / 1000}k`
                }
              />
              <ReTooltip content={<CustomTooltip />} />
              <Line
                dataKey="payment"
                stroke="#02CA70"
                strokeWidth={2}
                dot={{ stroke: "none", fill: "#02CA70" }}
              />
              <Line
                dataKey="refund"
                stroke="#FF574B"
                strokeWidth={2}
                dot={{ stroke: "none", fill: "#FF574B" }}
              />
              <Line
                dataKey="settlement"
                stroke="#3E7DFB"
                strokeWidth={2}
                dot={{ stroke: "none", fill: "#3E7DFB" }}
              />
            </LineChart>
          </ResponsiveContainer>
        )}

      </div>
               <div className="flex gap-[1.5vw] text-[2.5vw] justify-center items-center">
            {[
              { color: "#02CA70", label: "Collected Amount" },
              { color: "#FF574B", label: "Refunds" },
              { color: "#3E7DFB", label: "Settled Amount" },
            ].map(({ color, label }) => (
              <div
                key={label}
                className=" flex items-center gap-[0.25vw] px-[0.5vw] py-[0.1vw] rounded-[1.5vw]"
              >
                <div
                  className="rounded-full w-[1.5vw] h-[1.5vw]"
                  style={{ backgroundColor: color }}
                />
                <p>{label}</p>
              </div>
            ))}
          </div>
  </div>
          <div className="col-span-2 grid grid-cols-2 pt-[1vw] pb-[0.2vw]">
       

            <div className="col-span-3 grid grid-cols-4 gap-x-1 py-[0.5vw] ">
<div className="col-span-4">
  <div className="grid grid-cols-4 gap-[1.5vw]">
    <div className="col-span-1 bg-gradient-to-b from-[#A9F9EE] to-[#F9FFF1] rounded-[1.5vw] flex flex-col items-center text-right">
      <div className="flex items-center gap-[2vw] border-b-[0.3vw] " style={{ borderColor: "#535353" }}>
<div className="flex flex-col px-[1.5vw] py-[1vw] rounded-t-[1.5vw]" style={{ backgroundColor: "#4848484D" }}>
  <div className="flex items-center gap-x-[1vw]">
    <img
      src={icon1}
      alt="Razorpay icon"
      className="w-[5vw] h-[5vw] object-contain p-[0.8vw] rounded-full"
      style={{ backgroundColor: "#535353" }}
    />
    <span className="text-[2.5vw] text-[#737373] font-medium">Razorpay Fee</span>
  </div>
  <span className="text-[2.5vw] font-bold text-[#0A0A0A]">Paid</span>
</div>      
      </div>
      <p className="text-[4vw] font-bold text-center pt-[1vw] text-[#0A0A0A]">20K</p>
    </div>

    <div className="col-span-1 bg-gradient-to-b from-[#A9F9EE] to-[#F9FFF1] rounded-[1.5vw] flex flex-col items-center text-right">
      <div className="flex items-center gap-[2vw] border-b-[0.3vw] " style={{ borderColor: "#02CA70" }}>
        <div className="flex flex-col px-[1.5vw] py-[1vw] rounded-t-[1.5vw]" style={{ backgroundColor: "#02CA704D" }}>
            <div className="flex items-center gap-x-[1vw]">
          <img
            src={icon1}
            alt="Net Revenue icon"
            className="w-[5vw] h-[5vw]  object-contain p-[0.8vw] rounded-full"
            style={{ backgroundColor: "#02CA70" }}
          />
            <span className="text-[2.5vw] text-[#737373] font-medium">Net Revenue</span>
          </div>
          <span className="text-[2.5vw]  font-bold text-[#0A0A0A]">After Fees</span>
        </div>
      </div>
      <p className="text-[4vw]  font-bold  pt-[1vw] text-[#02CA70]">20K</p>
    </div>
    <div className="col-span-1 bg-gradient-to-b from-[#A9F9EE] to-[#F9FFF1] rounded-[1.5vw] flex flex-col items-center text-right">
      <div className="flex items-center gap-[2vw] border-b-[0.3vw] " style={{ borderColor: "#535353" }}>
        <div className="flex flex-col px-[1vw] py-[1vw] rounded-t-[1.5vw]" style={{ backgroundColor: "#4848484D" }}>
           <div className="flex items-center gap-x-[0.5vw] ">
          <img
            src={icon2}
            alt="Dispute icon"
            className="w-[5vw] h-[5vw] object-contain p-[0.8vw] rounded-full"
            style={{ backgroundColor: "#535353" }}
          />
            <span className="text-[2.5vw] text-[#737373] font-medium ">Chargeback / Dispute</span>
            
          </div>
          <span className="text-[2.5vw]  font-bold text-[#0A0A0A]">Values</span>
        </div>
      </div>
      <p className="text-[4vw]  font-bold   pt-[1vw] text-[#0A0A0A]">20K</p>
    </div>
    <div className="col-span-1 bg-gradient-to-b from-[#A9F9EE] to-[#F9FFF1] rounded-[1.5vw] flex flex-col items-center text-right">
      <div className="flex items-center gap-[2vw] border-b-[0.3vw] " style={{ borderColor: "#02CA70" }}>
        <div className="flex flex-col px-[1.5vw] py-[1vw] rounded-t-[1.5vw]" style={{ backgroundColor: "#02CA704D" }}>
            <div className="flex items-center gap-x-[1vw]">
          <img
            src={icon3}
            alt="Settlement icon"
            className="w-[5vw] h-[5vw]  object-contain px-[0.8vw] py-[0.8vw] rounded-full"
            style={{ backgroundColor: "#02CA70" }}
          />
            <span className="text-[2.5vw]  text-[#737373] font-medium">Average Settlement</span>
          </div>
            <span className="text-[2.5vw] font-bold text-[#0A0A0A]">Time</span>
        </div>
      </div>
      <p className="text-[4vw]  font-bold  pt-[1vw] text-[#02CA70]">20K</p>
    </div>

  </div>
</div>


</div>
</div>
</div>
  ):(
    <Commission/>
  )


           

   )}
          
        

    </div>  
    
  </div>
)
}








//   <div className="bg-yellow-400 col-span-1 rounded-[1.5vw] overflow-hidden relative">
//   {/* Header */}
//   <div className="px-[2vw] pt-[1.5vw] pb-[1vw] bg-yellow-500">
//     <p className="text-[4.3vw] text-white font-semibold z-[10]">
//       Pending Settlement
//     </p>
//   </div>

//   {/* Main Content */}
//   <div className="flex justify-between items-center px-[4vw] pb-[1vw]">
//     {/* Left Side - Text Content */}
//     <div className="text-white">
//       <div className="text-[5vw] font-bold">
//         {getRazorpayDetails?.cardDetails?.settledToBank >= 1000 ? (
//           <Tooltip
//             placement="right"
//             title={`₹ ${Number(getRazorpayDetails?.cardDetails?.settledToBank).toLocaleString("en-IN")}`}
//             className="cursor-pointer text-[#1F487C]"
//             color="white"
//             overlayInnerStyle={{
//               color: "#1F487C",
//               fontSize: "2vw",
//             }}
//           >
//             <span className="text-white">
//               ₹ {formatNumber(Number(getRazorpayDetails?.cardDetails?.settledToBank).toFixed(2))}
//             </span>
//           </Tooltip>
//         ) : (
//           <span className="text-white">
//             ₹ {Number(getRazorpayDetails?.cardDetails?.settledToBank).toFixed(2)}
//           </span>
//         )}
//       </div>

//       <p className="underline text-[3vw] cursor-pointer mt-[1vw]">
//         View Entire List
//       </p>
//     </div>

//     {/* Right Side - Image */}
//     <div className="w-[9vw] h-auto flex justify-center items-center">
//       <img
//         src={pendingimg}
//         className="w-full h-auto object-contain"
//         alt="Pending"
//       />
//     </div>
//   </div>
// </div>